// extracted by mini-css-extract-plugin
export default {"root":"-dT-Sy1L","active":"_4pNt-Qy0","media":"_28dA3jOL","unshrink":"NZrn2KR4"};